import(
  `./banner_pwa.scss`
)
